
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-optional-programme",
      function () {
        return require("private-next-pages/upsc-optional-programme/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-optional-programme"])
      });
    }
  